import React, { useLayoutEffect, useState, useEffect } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
    LoadPanel, MasterDetail, Selection
} from "devextreme-react/data-grid";
import Modal from "react-modal";
import { Button, DateBox, SelectBox, TextArea, TextBox, RadioGroup } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { PaymentRequestService } from '../../../apis/apiServices/PaymentRequest'
import { ProjectService } from '../../../apis/apiServices/Project'
import { CompanyService } from '../../../apis/apiServices/Company'
import { MsmeService } from '../../../apis/apiServices/Msme'
import { filter } from 'lodash';
import PaymentDetailsModal from '../../common/Modal/PaymentDetailsModal';



export default function PaymentRequestReportComponent(props) {
    useLayoutEffect(() => {
        document.querySelector("#pageTitle").innerHTML = "PR - Payment Request Report";
        getPaymentRequestList();
        getProjectDropdownData();
    }, []);
    const navigate = useNavigate();
    const [projectDropdownData, setProjectDropdownData] = useState(null);
    const [paymentRequestList, setPaymentRequestList] = useState(null);
    const [companyBankData, setCompanyBankData] = useState(null);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
    const [selectedCompanyBankId, setSelectedCompanyBankId] = useState(null);
    const [selectedMsmeId, setSelectedMsmeId] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isitemDetailsModalVisible, setIsitemDetailsModalVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [msme, setMsmeList] = useState(null);
    const [paymentModeList, setPaymentModeList] = useState(null);
    const [payment, setPayment] = useState({
        vendorName: '',
        balanceAmt: '',
        recommendedAmt: '',
        paidAmt: '',
        paidDate: '',
        transcationNumber: '',
        narration: '',
        paymentRequestId: '',
        itemId: 0,
        itemSerialNo: '',
    });

    const [paymentDeatilsSrno, setPaymentDetailsSrno] = useState(null);
    const [paymentDeatilsByPrId, setPaymentDetailsByPrId] = useState(null);
    const [paymentOptionList, setPaymentOptionList] = useState(["Bank", "MSME"]);
    const [companyMsmeDetails, setCompanyMsmeDetails] = useState(null);
    const [paymentOption, setPaymentOption] = useState(true);
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: 0,
        statusId: 0,
        requestNo: 0,
    });
    const [filterErrors, setFilterErrors] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const [loading, setLoading] = useState(false);
    const user = useSelector((state) => state.user.data);
    const ConvertDateToddMMyyyy = (date) => {
        if (!date) return "";
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    const getPaymentRequestList = async (isIgnoreFilters) => {
        try {
            setLoading(true);
            let body = {
                UserId: user?.userId,
                fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
                toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
                paymentRequestId: (filters?.requestNo && isIgnoreFilters !== true) ? filters?.requestNo : 0,
                projectId: (filters?.projectId && isIgnoreFilters !== true) ? filters?.projectId : 0,
                requestStatusId: 13,
            }
            setLoading(true);
            const response = await PaymentRequestService.getPaymentRequestList(body)
            setLoading(false);
            setPaymentRequestList(response?.data);
            return response?.data;
        } catch (error) {
            console.log("Error getFundRequestList===>", error);
        }
    }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }
    const getCompanyBankDetails = async (projectId) => {
        try {
            let body = {
                //'companyId': user?.companyId,
                'projectId': projectId,
            }
            const response = await CompanyService.getCompanyBankDetails(body)
            setCompanyBankData(response?.data);
        } catch (error) {
            console.log("Error getCompanyBankDetails===>", error);
        }
    }


    const getMsmeList = async () => {
        try {
            const response = await MsmeService.getMsmeList()
            const fiterData = response?.data.filter(item => item?.isActive === true)
            setMsmeList(fiterData);
        } catch (error) {
            console.log("Error getMsmeList===>", error);
        }
    }

    const getPaymentModeList = async () => {
        try {
            const response = await PaymentRequestService.getPaymentModeList()
            const fiterData = response?.data.filter(item => item?.isActive === true)
            setPaymentModeList(fiterData);
        } catch (error) {
            console.log("Error getMsmeList===>", error);
        }
    }



    const handleFilterChange = (key, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        const newErrors = {};
        if ((paymentOption === true) && !payment?.companyBankId) {
            newErrors.companyBankId = "Please select bank";
        }

        if ((paymentOption === false) && !payment?.msmeId) {
            newErrors.msmeId = "Please select MSME";
        }



        // if (!payment?.companyBankId) newErrors.companyBankId = "Please select bank";
        if (!payment?.narration) newErrors.narration = "Please enter narration";
        if (!payment?.transcationNumber) newErrors.transcationNumber = "Please enter transaction number";
        if (!payment?.paidDate) newErrors.paidDate = "Please select date";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitted(false);
            return;
        }

        const formatDate = (date) => {
            if (!date) return null;
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const day = String(d.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        };

        let body = {
            paymentRequestId: payment?.paymentRequestId,
            itemId: payment?.itemId,
            itemSerialNo: payment?.itemSerialNo,
            companyBankId: payment?.companyBankId,
            paidOn: formatDate(payment?.paidDate),
            transactionNo: payment?.transcationNumber,
            narration: payment?.narration,
            modifiedBy: user?.userId,
            msmeId: payment?.msmeId || 0,
            paymentModeId: payment?.paymentModeId || 0,
            paymentMode: paymentOption

        };

        const response = await PaymentRequestService.Payment(body);

        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.message || "Something went wrong"}`,
                "error"
            ); setIsSubmitted(false);
            return;
        }

        Swal.fire(
            "Success!",
            // `${response?.message || bank?.id > 0 ? "Bank updated successfully" : "Bank added successfully"}`,
            `${response?.message || "payment done successfully"}`,
            "success"
        ).then(() => { navigate("/payment-request"); });
    };

    const renderDetail = (detailData) => {
        const { data } = detailData; // parent row data
        return (
            <DataGrid
                dataSource={data?.items || []}  // <-- children list for this parent
                columnAutoWidth
                showBorders
                showRowLines
                showColumnLines={false}
                noDataText="No details"
            >
                {/*<Column
                    width="35px"
                    cellRender={(cellData) => {
                        //debugger
                        const rowData = cellData?.data;
                        return (
                            <>
                                
                                {(data?.isApproved === true && data?.paymentApproverUser) ?

                                    !rowData?.paidOn &&

                                    <button
                                        className="btn btn-outline-success btn-sm"
                                        style={{ padding: "0px 8px", margin: "0px", fontSize: "0.78rem", borderRadius: "50px", cursor: 'pointer' }}
                                        title='Pay'
                                        tooltip='Pay'
                                        onClick={() => openAddModal(rowData, data)}
                                    >Pay</button>
                                    :
                                    <span title='Payment'>
                                        <Icon
                                            title="Payment"
                                            className='iconify-size mr-1'
                                            icon="streamline-ultimate:cash-payment-bill-bold"
                                            style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                        />
                                    </span>
                                }
              

                            </>
                        );
                    }}
                /> */}
                <Column dataField="itemSerialNo" caption="Serial No." />
                <Column dataField="vendorName" caption="Vendor" />
                {/* <Column dataField="location" caption="Location" /> */}
                <Column dataField="bankName" caption="Bank"
                    cellRender={(e) => (
                        <div>
                            <div>{e.data?.bankName}</div>
                            <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.branchName}</div>
                        </div>
                    )}
                />
                {/* <Column dataField="itemStatus" caption="Status" /> */}
                <Column dataField="balanceAmt" caption="Ledger Balance" allowFiltering={false} allowSearch={true}
                    cellRender={(e) => (
                        <div> {e.data?.balanceAmt?.toLocaleString("en-IN", {})} </div>
                    )} />
                <Column dataField="recommendedAmt" caption="Recommended Amt." allowFiltering={false} allowSearch={true}
                    cellRender={(e) => (
                        <div> {e.data?.recommendedAmt?.toLocaleString("en-IN", {})} </div>
                    )}
                />
                <Column dataField="paidAmt" caption="Paid Amt." allowFiltering={false} allowSearch={true}
                    cellRender={(e) => (
                        <div> {e.data?.paidAmt?.toLocaleString("en-IN", {})} </div>
                    )}
                />
                <Column dataField="advPaymentRequestId" caption="Advance Request Id" allowEditing={false} width={150} />
                <Column
                    dataField=""
                    caption="Payment Status"
                    cellRender={(e) => (
                        <div style={{ textAlign: "center" }}>
                            {e.data?.paidOn ? (
                                <div title='More Info'>
                                    <Icon
                                        icon="material-symbols:check-circle-outline-rounded"
                                        title="Payment Done"
                                        style={{ color: "green", fontSize: "20px", cursor: 'pointer' }}
                                        onClick={() => getPaymentDeatilsByPrItemId(e.data?.itemId, e.data?.itemSerialNo)}
                                    />
                                    <div style={{ fontSize: '11px', color: '#b1b1b1' }}> {e.data?.paidOn
                                        ? (() => {
                                            const d = new Date(e.data.paidOn);
                                            const day = String(d.getDate()).padStart(2, "0");
                                            const month = String(d.getMonth() + 1).padStart(2, "0");
                                            const year = d.getFullYear();
                                            return `${day}-${month}-${year}`;
                                        })()
                                        : ""}</div>
                                </div>

                            ) : (
                                <Icon
                                    icon="mdi:clock-outline"
                                    title="Pending Payment"
                                    style={{ color: "gray", fontSize: "20px", opacity: 0.5 }}
                                />
                            )}
                        </div>
                    )}
                />

            </DataGrid>
        );
    };

    const openAddModal = (rowData, data) => {
        setIsPaymentModalOpen(true);
        getCompanyBankDetails(data?.projectId);
        getMsmeList();
        getPaymentModeList();
        setPayment({
            vendorName: rowData?.vendorName,
            balanceAmt: rowData?.balanceAmt,
            recommendedAmt: rowData?.recommendedAmt,
            paidAmt: rowData?.paidAmt,
            paymentRequestId: data?.paymentRequestId,
            itemId: rowData?.itemId,
            itemSerialNo: rowData?.itemSerialNo,
        });
    };
    const closeModal = () => {
        setIsPaymentModalOpen(false);
        setIsSubmitted(false);
        setErrors({});
        setIsitemDetailsModalVisible(false);
        setPaymentDetailsByPrId(null);
        // setCompanyBankData(null);
        setSelectedCompanyBankId(null);
        setSelectedMsmeId(null);
        setPaymentOption(true)
        // setBank({
        //     bankName: '',
        //     bankId: '',
        //     isActive: true,
        //     id: 0,
        // });
        // setBranches([]);
    };

    const paymentoptionChangeHandler = (value) => {
        const opt = (value === paymentOptionList[0]) ? true : false;
        setPaymentOption(opt);
        if (value === paymentOptionList[0]) {

            setSelectedMsmeId(null)
        }
        if (value === paymentOptionList[1]) {
            setSelectedCompanyBankId(null)
        }

    }



    const handleValueChange = (field, value) => {
        setPayment(prev => ({
            ...prev,
            [field]: value
        }));

        // Optional: Clear validation error when field changes
        setErrors(prev => ({
            ...prev,
            [field]: ''
        }));
        // 👇 If this is the company bank selection, update local state
        if (field === "companyBankId") {
            setSelectedCompanyBankId(value);
        }
        if (field === "MSMEId") {
            setSelectedMsmeId(value);
        }
    };


    const getPaymentDeatilsByPrItemId = async (itemId, serialNo) => {
        try {
            const response = await PaymentRequestService.getitemPaymentDetailsById(itemId)
            const paymentSrNo = { paymentRequestId: response?.data, itemSerialNo: serialNo }
            setPaymentDetailsByPrId(response?.data, serialNo);
            setPaymentDetailsSrno(serialNo)

            setIsitemDetailsModalVisible(true)
        } catch (error) {
            console.log("Error getPaymentDeatilsByPrItemId===>", error);
        }
    }


    const calculateCellValue = (input) => {
        const date = new Date(input);
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        const formatted = `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
        return formatted;


    }

    const calculateCellValue2 = (dateValue) => {
        if (!dateValue) return "";
        const d = new Date(dateValue);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const deletePR = async (paymentRequestId, serialNo) => {
        //e.preventDefault();
        // if (!remarks.trim()) {
        //     setError("Please enter remarks");
        //     return;
        // }
        // setIsDeleteModalVisible(false);
        // setRemarks("");
        const result = await Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: 'You want to delete this payment request?',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
        });

        if (!result.isConfirmed) return;

        let body = {
            paymentRequestId: paymentRequestId,
            serialNo: serialNo,
            modifiedFeatureId: props?.featurePermission?.featureId,
        };
        const response = await PaymentRequestService.deletePR(body);
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            );
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => { navigate("/payment-request") });
        getPaymentRequestList();
    };


    return (
        <>
            <div className="content">
                {/* Filters */}
                <div className="card filter">
                    <div className="card-body">
                        <div className="row">
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    From
                                </label>
                                <DateBox
                                    placeholder="Select date"
                                    value={filters?.fromDate}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("fromDate", e?.value)
                                    }
                                    }
                                    displayFormat="dd/MM/yyyy"
                                />
                                {filterErrors?.fromDate && <span className="error invalid-feedback">{filterErrors?.fromDate}</span>}
                            </div>
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    To
                                </label>
                                <DateBox
                                    placeholder="Select date"
                                    value={filters?.toDate}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("toDate", e?.value)
                                    }}
                                    displayFormat="dd/MM/yyyy"
                                />
                                {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>}
                            </div>
                            {/* <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    Status <span className="text-danger"></span>
                                </label>
                                <SelectBox
                                    //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                    //dataSource={iomStatusDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select status"
                                    searchEnabled
                                    showClearButton={false}
                                    value={filters?.statusId}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("statusId", e?.value)
                                    }}
                                />
                            </div> */}
                            {/* <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    Request No.<span className="text-danger"></span>
                                </label>
                                <SelectBox
                                    //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                    //dataSource={requestNoDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select request no."
                                    searchEnabled
                                    showClearButton={false}
                                    value={filters?.requestNo}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("requestNo", e?.value)
                                    }}
                                />
                            </div> */}
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    Project <span className="text-danger"></span>
                                </label>
                                <SelectBox
                                    dataSource={projectDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select project"
                                    searchEnabled
                                    showClearButton={false}
                                    value={filters?.projectId}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("projectId", e?.value)
                                    }}
                                />
                            </div>
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label style={{ display: "block" }}>&nbsp;</label>
                                <button
                                    className="btn btn-primary btn-sm mt-2 mr-2"
                                    title='Filter'
                                    tooltip='Filter'
                                    onClick={getPaymentRequestList}
                                >
                                    <Icon className='iconify-size mr-1' icon="hugeicons:filter" />
                                    Filter
                                </button>
                                <button
                                    className="btn btn-outline-primary btn-sm mt-2"
                                    title='Clear'
                                    tooltip='Clear'
                                    onClick={() => {
                                        setFilters(prevState => {
                                            return {
                                                ...prevState,
                                                fromDate: "",
                                                toDate: "",
                                                projectId: 0,
                                                statusId: 0,
                                                requestNo: 0,
                                            }
                                        })
                                        getPaymentRequestList(true);
                                    }}
                                >
                                    <Icon className='iconify-size mr-1' icon="hugeicons:eraser" />
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Data Grid */}
                <div className='card'>
                    <div className='card-body'>
                        <DataGrid
                            dataSource={paymentRequestList}
                            className='iom-grid grd-payment-request'
                            columnAutoWidth
                            showBorders
                            showColumnLines={false}
                            showRowLines={true}
                            allowFiltering
                            columnHidingEnabled
                            onToolbarPreparing={(e) => {
                                e.toolbarOptions.items.unshift({
                                    location: "before",
                                    widget: "dxButton",
                                    options: {
                                        icon: "refresh",
                                        text: "Refresh",
                                        type: "default",
                                        stylingMode: "outlined",
                                        onClick: () => getPaymentRequestList(),
                                        hint: "Refresh",
                                    }
                                });
                                // e.toolbarOptions.items.unshift({
                                //     location: "before",
                                //     widget: "dxButton",
                                //     visible: (props?.isAllowedForThisRole || props?.featurePermission?.canAdd) ? true : false,
                                //     options: {
                                //         icon: "plus",
                                //         text: "New",
                                //         type: "default",
                                //         stylingMode: "contained",
                                //         onClick: () => navigate("/new-payment-request"),
                                //         hint: "New Fund Request",
                                //     }
                                // });
                            }}
                        >
                            <Column
                                width="95px"
                                cellRender={(cellData) => {

                                    const rowData = cellData?.data;
                                    // Check if user is approver in stageIndex == 1
                                    const isUserApproverStage1 = rowData?.actionDetails?.some(
                                        (ad) =>
                                            ad?.stageIndex === 1 &&
                                            ad?.approvers?.some((app) => app?.userId === user?.userId)
                                    );
                                    return (
                                        <>
                                            {/* View */}
                                            <span title='View'>
                                                <Icon
                                                    title="View"
                                                    className='iconify-size mr-1'
                                                    icon="solar:document-text-outline"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                        navigate("/view-payment-request", { state: { paymentRequestId: rowData?.paymentRequestId, IsShowButtons: false } })
                                                    }
                                                />
                                            </span>
                                            {/* Edit */}
                                            {isUserApproverStage1 && [8, 15, 4].includes(rowData?.requestStatusId) ? (
                                                <span title="Edit">
                                                    <Icon
                                                        title="Edit"
                                                        className="iconify-size mr-1"
                                                        icon="solar:pen-line-duotone"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                            navigate("/add-edit-payment-request", { state: { paymentRequestId: rowData?.paymentRequestId, IsShowButtons: true } })
                                                        }
                                                    />
                                                </span>
                                            ) : (
                                                <span>
                                                    <Icon
                                                        title="Edit"
                                                        className="iconify-size mr-1"
                                                        icon="solar:pen-line-duotone"
                                                        style={{
                                                            cursor: "pointer",
                                                            pointerEvents: "none",
                                                            opacity: "0.3",
                                                        }}
                                                    />
                                                </span>
                                            )}

                                            {/* Delete */}
                                            {isUserApproverStage1 && (rowData?.requestStatusId === 8 || rowData?.requestStatusId === 15) ? (
                                                <span title="Delete">
                                                    <Icon
                                                        title="Delete"
                                                        className="iconify-size"
                                                        icon="fluent:delete-32-regular"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            deletePR(rowData?.paymentRequestId, rowData?.serialNo);
                                                        }}
                                                    />
                                                </span>
                                            ) : (
                                                <span>
                                                    <Icon
                                                        title="Delete"
                                                        className="iconify-size"
                                                        icon="fluent:delete-32-regular"
                                                        style={{
                                                            cursor: "pointer",
                                                            pointerEvents: "none",
                                                            opacity: "0.3",
                                                        }}
                                                    />
                                                </span>
                                            )}

                                        </>
                                    );
                                }}
                            />
                            <Column dataField="projectName" caption="Project" allowFiltering={false} allowSearch={true} />
                            <Column dataField="departmentName" caption="Department" allowFiltering={false} allowSearch={true} />
                            <Column dataField="serialNo" allowSearch={true} caption="Request No." width='250px' allowFiltering={false}
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data?.serialNo}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.fundRequestSerialNo}</div>
                                    </div>
                                )}
                            />
                            <Column
                                caption="From"
                                allowSearch={true}
                                calculateCellValue={(cellData) => `${cellData?.fromUser || ""} ${cellData?.fromUserDepartment || ""}`}
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data.createdBy}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.fromUserDepartment}</div>
                                    </div>
                                )}
                            />
                            {/* <Column dataField="requestStatus" caption="Status" allowFiltering={false} allowSearch={true} /> */}
                            <Column
                                // dataField="nextUserStatusText"
                                caption="Status"
                                allowSearch={true}
                                calculateCellValue={(cellData) => `${cellData?.requestStatusId === 8 ? "Drafted"
                                    : cellData?.requestStatusId === 4 ? "Revised Draft"
                                        : cellData?.nextUserStatusText ?? "Approved"
                                    }
                                ${cellData?.nextUser?.trim() === "" ? cellData?.lastUpdatedByUser : cellData?.nextUser}
                                `

                                }
                                cellRender={(e) => {
                                    let color = '#28A745';
                                    if (e.data?.requestStatusId === 4) color = 'gray';
                                    else if (e.data?.requestStatusId === 1) color = '#333131ff';
                                    else if (e.data?.requestStatusId === 2) color = '#FF9800';
                                    else if (e.data?.requestStatusId === 3) color = 'orange';
                                    else if (e.data?.requestStatusId === 7) color = '#ff9800';
                                    else if (e.data?.requestStatusId === 11) color = '#ff9800';
                                    else if (e.data?.requestStatusId === 14) color = '#ff9800';
                                    else if (e.data?.requestStatusId === 15) color = '#24adecff';
                                    return (
                                        <div>
                                            {(e.data?.requestStatusId === 8) ? (
                                                <span style={{ color: '#6C757D' }}>Drafted</span>
                                            ) : (e.data?.requestStatusId === 4) ? (
                                                <span style={{ color: '#DC3545' }}>Revised Draft</span>
                                            ) : (e.data?.requestStatusId === 9) ? (
                                                <span style={{ color: '#DC3545' }}>Recall Requested</span>
                                            ) : (e.data?.requestStatusId === 11) ? (
                                                <span style={{ color: '#ff9800' }}>{e?.data?.requestStatus}</span>
                                            ) : (
                                                <span style={{ color }}>{e?.data?.nextUserStatusText ?? e?.data?.requestStatus}</span>
                                            )}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                                                {e.data?.nextUser?.trim() === "" ? e.data?.lastUpdatedByUser : e.data?.nextUser}
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                            <Column dataField="totalBalanceAmt" caption="Total Ledger Balance" allowFiltering={false} allowSearch={true}
                                cellRender={(e) => (
                                    <div> {e.data?.totalBalanceAmt?.toLocaleString("en-IN", {})} </div>
                                )}
                            />
                            <Column dataField="totalRecommendedAmt" caption="Total Recommended Amt." allowFiltering={false} allowSearch={true}
                                cellRender={(e) => (
                                    <div> {e.data?.totalRecommendedAmt?.toLocaleString("en-IN", {})} </div>
                                )}
                            />
                            <Column dataField="totalPaidAmt" caption="Total Paid Amt." allowFiltering={false} allowSearch={true}
                                cellRender={(e) => (
                                    <div> {e.data?.totalPaidAmt?.toLocaleString("en-IN", {})} </div>
                                )}
                            />
                            <Column
                                dataField="createdOn"
                                caption="Created On"
                                width="150px"
                                allowFiltering={false}
                                allowSearch={true}
                                calculateCellValue={(cellData) => {
                                    const date = new Date(cellData?.createdOn);
                                    return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`
                                }}
                                cellRender={(e) => {
                                    const date = new Date(e.data.createdOn);
                                    return (
                                        <>
                                            <div>
                                                {date.toLocaleDateString('en-GB')}&nbsp;
                                                {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                                <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data?.fromUser}</div>
                                            </div>
                                        </>
                                    );
                                }}
                            />
                            <Column
                                dataField="lastUpdatedOn"
                                caption="Last Updated"
                                allowFiltering={false}
                                width="150px"
                                allowSearch={true}
                                calculateCellValue={(cellData) => {
                                    const date = new Date(cellData?.lastUpdatedOn);
                                    return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                ${cellData?.lastUpdatedByUser}`
                                }}
                                cellRender={(e) => {
                                    if (!e.data.lastUpdatedOn) return null;
                                    const date = new Date(e.data.lastUpdatedOn);
                                    return (
                                        <div>
                                            {date.toLocaleDateString('en-GB')}&nbsp;
                                            {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data.lastUpdatedByUser}</div>
                                        </div>
                                    );
                                }}
                            />
                            {/* Master Detail */}
                            <MasterDetail enabled={true} render={renderDetail} />
                            <HeaderFilter visible={true} />
                            <LoadPanel
                                //shadingColor="rgba(179, 34, 34, 0.4)"
                                //position={position}
                                visible={loading}
                                showIndicator={true}
                                //shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <SearchPanel
                                visible={true}
                                highlightCaseSensitive={false}
                                highlightSearchText={true}
                                width={240}
                                placeholder="Search..."
                            />
                            <LoadPanel
                                //shadingColor="rgba(179, 34, 34, 0.4)"
                                //position={position}
                                visible={loading}
                                showIndicator={true}
                                //shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <Paging defaultPageSize={15} />
                            <Pager
                                visible={true}
                                allowedPageSizes={[10, 15, 20, 50, 100]}
                                showPageSizeSelector={true}
                                showInfo={true}
                                showNavigationButtons={true}
                            />
                            <Export enabled={false} fileName="Fund Request" />
                        </DataGrid>
                    </div>
                </div>
            </div>
            {/* Payment Modal */}
            <Modal
                ariaHideApp={false}
                isOpen={isPaymentModalOpen}
                className="react-modal custom-modal-xlarge"
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="Payment Modal"
            >
                <form
                    // onSubmit={}
                    style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
                >
                    <div className="modal-header">
                        <h6 className="modal-title">
                            {"Payment Request "}
                        </h6>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12'>
                                <table className='request-details'>
                                    <tr>
                                        <td><Icon icon="hugeicons:file-02" className='iconify-style' /></td>
                                        <td>
                                            <div className='fieldlable'>Vendor</div>
                                            <div className='fieldvalue'>{payment?.vendorName}</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <table className='request-details'>
                                    <tr>
                                        <td><Icon icon="si:rupee-fill" className='iconify-style' /></td>
                                        <td>
                                            <div className='fieldlable'>Ledger Balance</div>
                                            <div className='fieldvalue'>{payment?.balanceAmt}</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <table className='request-details'>
                                    <tr>
                                        <td><Icon icon="si:rupee-fill" className='iconify-style' /></td>
                                        <td>
                                            <div className='fieldlable'>Recommended Amt.</div>
                                            <div className='fieldvalue'>{payment?.recommendedAmt}</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <table className='request-details'>
                                    <tr>
                                        <td><Icon icon="si:rupee-fill" className='iconify-style' /></td>
                                        <td>
                                            <div className='fieldlable'>Amount to be Paid</div>
                                            <div className='fieldvalue'>{payment?.paidAmt}</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>


                        {/* payment option */}



                        <div className='row'>

                            <div className='col-lg-9 col-md-8 col-sm-12'>
                                <div class="sub-title-color mt-3">Select Payment Via</div>
                                <div>
                                    <RadioGroup
                                        layout="horizontal"
                                        items={paymentOptionList}
                                        defaultValue={paymentOption}
                                        //onValueChanged={(e) => setPaymentOption(e.value)} 
                                        onValueChanged={(e) => paymentoptionChangeHandler(e.value)}
                                    />
                                </div>
                            </div>
                        </div>


                        {/* payment option */}

                        {(paymentOption === true) && (

                            <div className='mb-2'>
                                <div class="sub-title-color mt-3">Select bank for payment to be done</div>
                                {/* DataGrid */}
                                {/* {branches.length > 0 && payment?.isAddBranch && ( */}
                                <DataGrid
                                    dataSource={companyBankData}
                                    keyExpr="companyBankId"
                                    columnAutoWidth={true}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={true}
                                    allowColumnResizing={false}
                                    height={185}
                                >
                                    {/* Radio button column */}
                                    <Column
                                        width={60}
                                        caption=""
                                        cellRender={({ data }) => (
                                            <input
                                                type="radio"
                                                name="companyBankSelect"
                                                checked={selectedCompanyBankId === data.companyBankId}
                                                onChange={() => handleValueChange("companyBankId", data.companyBankId)}
                                                style={{ cursor: "pointer" }}
                                            />
                                        )}
                                    />

                                    <Column dataField="bankName" caption="From Bank" />
                                    <Column dataField="branchName" caption="Branch" />
                                    <Column dataField="accountHolderName" caption="Account Holder Name" />
                                    <Column dataField="accountNo" caption="Account Number" />
                                    <Column dataField="accountType" caption="Account Type" />
                                    <Column dataField="ifscCode" caption="IFSC Code" />
                                    <Paging defaultPageSize={3} />
                                </DataGrid>

                                {errors?.companyBankId && <div className="text-danger">{errors.companyBankId}</div>}
                                {/* )} */}
                            </div>
                        )}

                        {(paymentOption === false) && (
                            <div className='mb-2'>
                                <div class="sub-title-color mt-3">Select MSME for payment to be done</div>
                                <SelectBox
                                    width={200}
                                    dataSource={msme}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select MSME"
                                    searchEnabled
                                    showClearButton={false}
                                    value={payment?.msmeId}
                                    onValueChanged={(e) => {
                                        e?.value && handleValueChange("msmeId", e?.value)
                                    }}
                                />
                                {errors?.msmeId && <div className="text-danger">{errors.msmeId}</div>}
                            </div>
                        )}




                        <div className='row'>
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <label>Paid On<span className="text-danger"> *</span></label>
                                <DateBox
                                    placeholder="Select date"
                                    value={payment?.paidDate}
                                    onValueChanged={(e) => {
                                        e?.value && handleValueChange("paidDate", e?.value)
                                    }}
                                    displayFormat="dd/MM/yyyy"
                                />
                                {errors?.paidDate && <div className="text-danger">{errors.paidDate}</div>}
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <label>Payment Mode<span className="text-danger"> *</span></label>
                                <SelectBox
                                    dataSource={paymentModeList}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select payment mode"
                                    searchEnabled
                                    showClearButton={false}
                                    value={payment?.paymentModeId}
                                    onValueChanged={(e) => {
                                        e?.value && handleValueChange("paymentModeId", e?.value)
                                    }}
                                />
                                {errors?.paidDate && <div className="text-danger">{errors.paidDate}</div>}
                            </div>
                            <div className='col-lg-4 col-md-4 col-sm-12'>
                                <label>
                                    Transaction Number <span className="text-danger">*</span>
                                </label>
                                <TextBox
                                    placeholder='Enter transcation number'
                                    value={payment?.transcationNumber}
                                    onValueChanged={(e) => handleValueChange("transcationNumber", e.value)}
                                //height={70}
                                />
                                {errors?.transcationNumber && <div className="text-danger">{errors.transcationNumber}</div>}
                            </div>
                            <div className='col-lg-12 col-md-12 col-sm-12'>
                                <label>
                                    Narration <span className="text-danger">*</span>
                                </label>
                                <TextArea
                                    placeholder='Enter narration '
                                    value={payment?.narration}
                                    onValueChanged={(e) => handleValueChange("narration", e.value)}
                                    height={70}
                                />
                                {errors?.narration && <div className="text-danger">{errors.narration}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={closeModal}
                            title="Cancel"
                        >
                            <i className="fas fa-times"></i> Cancel
                        </button>

                        <button
                            type="submit"
                            className="btn btn-primary btn-sm"
                            style={{ display: isSubmitted ? "none" : "" }}
                        >
                            {isSubmitted ? (
                                <span title="In process">
                                    <i className="fas fa-spinner fa-spin"></i> In process
                                </span>
                            ) : (
                                <span title="Submit"
                                    onClick={handlePaymentSubmit}
                                >
                                    <i className="fas fa-check"></i>{" "}
                                    {payment?.id ? "Update" : "Submit"}
                                </span>
                            )}
                        </button>
                    </div>
                </form>
            </Modal>


            {/* Payment deails Modal */}
            <PaymentDetailsModal paymentDeatilsByPrId={paymentDeatilsByPrId} paymentDeatilsSrno={paymentDeatilsSrno} closeModal={closeModal} isitemDetailsModalVisible={isitemDetailsModalVisible} isSubmitted={isSubmitted} title="Payment Request Details" />
        </>
    )
}